import React from 'react'
import { CCard, CImage } from '@coreui/react-pro'
import './DateOfService.scss'
import PropTypes from 'prop-types'
import MobiScrollCalender from 'src/components/common/MobiScrollCalendar/MobiScrollCalendar'
import tick from '../../../assets/icons/Encounter-Progress.svg'
import aiTick from '../../../assets/icons/Encounter-ProgressAI.svg'
import { dateUSFormat } from '../../../utils/dateTimeUtils'
import { getIsAi } from '../../../utils/sharedFeaturesFunctions'

export default function DateOfServiceCard({ setDateOfService, dateOfService }) {
  return (
    <CCard className="DateofService">
      <div className="encounter-details-CardHeader">
        <span className="titlte-holder">
          {dateOfService ? (
            <CImage className="tick-size-dos" src={getIsAi() ? aiTick : tick} />
          ) : (
            <span className="encounter-progress-number nonactive-number-progress-encounter"></span>
          )}

          <p className="title-padding">Date of service</p>
        </span>
        <span className="encounter-deteofservice-input">
          <span>
            <MobiScrollCalender
              placeholder="MM / DD / YYYY"
              value={dateUSFormat(dateOfService)}
              handleDateChange={(date) => {
                setDateOfService(dateUSFormat(date))
              }}
            ></MobiScrollCalender>
          </span>
        </span>
        {dateOfService && <span className="completed-container completed-text">COMPLETED</span>}
      </div>
    </CCard>
  )
}
DateOfServiceCard.propTypes = {
  setDateOfService: PropTypes.any,
  dateOfService: PropTypes.any,
}
